import { z } from "zod";
import { locales } from "../models.js";

export default {
  params: z.object({
    newEmail: z.email(),
    locale: z.enum(locales),
  }),
  response: z.void(),
};
